import logger from 'ws-scripts/modules/logger';
import { updateLsWidgetState } from '../helpers';

const stepsActionRegex = new RegExp('steps/set*');

const publishToStepTracker = (steps = {}) => {
	const pubsub = window?.DDC?.pubsub;
	if (pubsub) {
		pubsub.publish('ws-track-my-offer/step-tracker', {
			...steps
		});
		logger.info(
			`WS-TRACK-MY-OFFER -> ws-track-my-offer/step-tracker: ${JSON.stringify(
				steps,
				null,
				2
			)}`
		);
	}
};

export const persistStepsMiddleware = (store) => (next) => (action) => {
	const result = next(action);

	// after steps action is dispatched(hits the reducer)
	// then store the complete steps into Local Storage
	// publish steps data to step tracker view
	if (stepsActionRegex.test(action.type)) {
		const { vehicleId, steps, prefs } = store.getState();
		if (vehicleId && prefs?.trackMyOfferView === 'paymentSelector') {
			updateLsWidgetState(vehicleId, steps);
			publishToStepTracker(steps);
		}
	}
	return result;
};
